/**
 * 物联网设备管理（InternetDeviceManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/InternetDeviceManagement/modules/ 下弹窗组件（第 2 组）
 * 通用词与第 1 组已有译法（en-US.js / InternetDeviceManagement.js）复用，此处仅收录新增条目
 */
export default {
  // ==================== 表端实时数据/状态详情 ====================
  '表端实时数据': 'Meter Real-time Data',
  '表端状态信息': 'Meter Status Info',
  '表端信号状态': 'Meter Signal Status',
  '表端工作模式': 'Meter Working Mode',
  '正向累积量(m³)': 'Forward Total Flow (m³)',
  '反向累积量(m³)': 'Reverse Total Flow (m³)',
  '瞬时流量(m³/h)': 'Instantaneous Flow (m³/h)',
  '流量(m³)': 'Flow (m³)',
  '日结累计流量(m³)': 'Daily Settlement Total Flow (m³)',
  '日冻结数据(m³)': 'Daily Freeze Data (m³)',
  '当前累积量(m³)': 'Current Total Flow (m³)',
  '当前累积逆量(m³)': 'Current Reverse Total Flow (m³)',
  '水压(MPa)': 'Water Pressure (MPa)',
  '压力值': 'Pressure',
  '信号强度(CSQ)': 'Signal Strength (CSQ)',
  '信噪比(SNR)': 'SNR',
  '接收信号功率(RSRP)': 'RSRP',
  '覆盖等级(ECL)': 'Coverage Level (ECL)',
  '小区ID(CellID)': 'Cell ID',
  '内核温度(℃)': 'Core Temperature (℃)',
  '当前水温(℃)': 'Water Temperature (℃)',
  '累计工作时间(分钟)': 'Cumulative Working Time (min)',
  '本次通讯耗时(s)': 'Communication Time (s)',
  '累计发送成功次数': 'Total Successful Sends',
  '累计发送失败次数': 'Total Failed Sends',
  '上报次数': 'Report Count',
  '定时上报周期': 'Scheduled Reporting Cycle',
  '开户状态': 'Account Status',
  '未开户': 'Account Not Opened',
  '已开户': 'Account Opened',
  '强制关': 'Forced Close',
  '强制开': 'Forced Open',
  '强制状态': 'Forced Status',
  '剩余金额状态': 'Remaining Amount Status',
  '剩余金额正常': 'Remaining Amount Normal',
  '剩余金额到达报警金额': 'Remaining Amount Reached Alarm Amount',
  '剩余金额到达透支金额': 'Remaining Amount Reached Overdraft Amount',
  '试用量(m³)': 'Trial Quantity (m³)',
  '当前剩余金额(元)': 'Current Remaining Balance (CNY)',
  '状态字信息': 'Status Word Info',
  '解卡功能有无异常': 'Card Reader Fault',
  '换能器状态': 'Transducer Status',
  '低温报警': 'Low Temperature Alarm',
  '高温报警': 'High Temperature Alarm',
  '空管报警': 'Empty Pipe Alarm',
  '空管是否报警': 'Empty Pipe Alarm',
  '滴漏报警': 'Drip Leak Alarm',
  '爆管(过流)报警': 'Pipe Burst (Overcurrent) Alarm',
  '关阀是否故障': 'Valve Close Fault',
  '开阀是否故障': 'Valve Open Fault',
  '无故障': 'No Fault',
  '超时故障': 'Timeout Fault',
  '堵转故障': 'Stall Fault',
  '有故障': 'Faulty',
  '阀门卡控制有无': 'With Valve Card Control',
  '阀门是否有故障': 'Valve Fault',
  '终端协议版本号': 'Terminal Protocol Version',
  '数据加密状态': 'Encryption Status',
  '未加密': 'Unencrypted',
  '系统是否报警': 'System Alarm',
  '切除是否报警': 'Cut-off Alarm',
  '无数据': 'No Data',
  '数据': 'Data',
  // ==================== 抄表卡打印 ====================
  '注册日期': 'Registration Date',
  '上年底数': 'Last Year End Reading',
  '上月表数': 'Last Month Reading',
  '本月表数': 'Current Month Reading',
  '用水量m³': 'Water Usage (m³)',
  '日': 'Day',
  'yyyy年MM月dd日': 'MM/dd/yyyy',
  // ==================== 新/US 协议命令下发（终端参数设置） ====================
  '阀门使能': 'Valve Enable',
  '秘钥': 'Key',
  // ==================== 命令队列 ====================
}
